import { ArrowLeft } from 'lucide-react';
import { DeckardIconWrapper } from './DeckardIcon';

export const BackIcon = DeckardIconWrapper({ Icon: ArrowLeft });
